"use strict";

exports.__esModule = true;
exports.formatDate = void 0;
var LANGUAGE_MAP = {
  en: 'en-US',
  fr: 'fr-FR'
};
var formatDate = function formatDate(milliseconds, language) {
  var date = new Date(milliseconds);
  var languageMap = LANGUAGE_MAP[language];
  var options = {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  };
  var parts = date.toLocaleDateString(languageMap, options).split(' ');

  // Helper function to capitalize only the first letter
  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Custom formatting for French: Month Day, Year
  if (languageMap === 'fr-FR') {
    var monthCapitalized = capitalizeFirstLetter(parts[1]);
    return monthCapitalized + " " + parts[0] + ", " + parts[2];
  }

  // Default formatting for other languages
  var formattedDate = date.toLocaleDateString(language, options);
  var _formattedDate$split = formattedDate.split(' '),
    month = _formattedDate$split[0],
    day = _formattedDate$split[1],
    year = _formattedDate$split[2];
  return capitalizeFirstLetter(month) + " " + day + " " + year;
};
exports.formatDate = formatDate;